import styled, { css } from 'styled-components';
import { SHARED_Z_INDEX } from './constants.js';
import { OverlayType } from './types.js';

var getDisplayState = function getDisplayState(props) {
  if (props.isVisible) {
    return css(["opacity:0.75;pointer-events:initial;"]);
  }

  return css(["opacity:0;pointer-events:none;"]);
};

var getBackgroundForKind = function getBackgroundForKind(props) {
  switch (props.kind) {
    case OverlayType.Transparent:
      return 'transparent';

    case OverlayType.Light:
    case OverlayType.Loading:
      return props.themeColors.OverlayBackgroundLoading;

    case OverlayType.Dark:
    default:
      return props.themeColors.OverlayBackgroundDefault;
  }
};

var getTransition = function getTransition(props) {
  if (props.isAnimated) {
    return css(["transition:0.3s ease-in-out all;"]);
  }

  return null;
};

var OverlayContent = styled.div.withConfig({
  displayName: "styles__OverlayContent",
  componentId: "sc-pvucs9-0"
})(["position:relative;z-index:", ";"], SHARED_Z_INDEX);
var OverlayLayer = styled.div.withConfig({
  displayName: "styles__OverlayLayer",
  componentId: "sc-pvucs9-1"
})(["position:absolute;z-index:", ";background-color:", ";top:0;bottom:0;left:0;right:0;width:100%;height:100%;", " ", ""], SHARED_Z_INDEX, getBackgroundForKind, getDisplayState, getTransition);
var OverlayContainer = styled.div.withConfig({
  displayName: "styles__OverlayContainer",
  componentId: "sc-pvucs9-2"
})(["position:relative;width:100%;height:100%;"]);
var ContentContainer = styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-pvucs9-3"
})(["position:absolute;margin:auto;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;"]);

export { ContentContainer, OverlayContainer, OverlayContent, OverlayLayer };
